import { Routes } from '@angular/router';

export const ROUTES: Routes = [
  {
    path: 'admin',
    loadChildren: './+admin#AdminModule'
  },
  {
    path: '',
    loadChildren: './+web#WebModule'
  }
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.routes.ts